import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'
import store from '@/store'
import VueCookies from 'vue-cookies'
import * as Sentry from '@sentry/vue'
import SVGIcon from '@/components/SVGIcon'
import ScreenSizePlugin from '@/utils/ScreenSizePlugin'
import configuration from './configuration'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(ScreenSizePlugin)
Vue.component('svg-icon', SVGIcon)

if (process.env.APP_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: configuration.sentryUrl,
    tracingOptions: {
      trackComponents: true
    },
    tracesSampleRate: 1.0
  })
}
export default new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
